export const START_FETCH_ATTENDEE_LIST = 'START_FETCH_ATTENDEE_LIST'
export const SUCCESS_FETCH_ATTENDEE_LIST = 'SUCCESS_FETCH_ATTENDEE_LIST'
export const FAILED_FETCH_ATTENDEE_LIST = 'FAILED_FETCH_ATTENDEE_LIST'

import getAttendeeList from 'controllers/ticket/getAttendeeList'

export function fetchAttendeeList(schoolId, params){

  return function(dispatch) {

    dispatch({
      type: START_FETCH_ATTENDEE_LIST,
    })

    getAttendeeList(schoolId, params)
    .then((result) => {
      dispatch({
        type: SUCCESS_FETCH_ATTENDEE_LIST,
        payload: {...result}
      })
    })
    .catch((err)  => {
      dispatch({
        type: FAILED_FETCH_ATTENDEE_LIST,
        payload: err
      })
    })
  }
}


const initState = {
  list: []
}

export default function attendeeList(state = initState, action){
  switch(action.type){
    case START_FETCH_ATTENDEE_LIST: {
      return {...state, fetching: true}
    }
    case SUCCESS_FETCH_ATTENDEE_LIST: {
      return {
        ...state,
        list: action.payload.result_list,
        count: action.payload.total_amount,
        posterTitle: action.payload.poster_title,
        fetching: false,
      }
    }
    case FAILED_FETCH_ATTENDEE_LIST: {
      return {
        ...state,
        error: action.payload,
      }
    }

    default: return {...state}
  }
}

//



// WEBPACK FOOTER //
// ./src/containers/pages/Poster/RegistrationTable/ducks.js